import React, { useEffect } from "react";
import ClinicPrintFrame from "../../../../Components/GeneralComponents/ClinicPrintFrame.js";

const headerCell = {
  padding: "8px",
  border: "1px solid #dbe6ea",
  fontWeight: "bold",
  fontSize: "3.1mm",
  color: "#0b8eb0",
  textAlign: "left",
};

const bodyCell = {
  padding: "8px",
  border: "1px solid #edf2f5",
  fontSize: "3mm",
  color: "#222",
};

const LaboratoryResultPaper = ({ labTest, tests }) => {
  const formatDate = (date) => {
    if (!date) return "";
    return new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "short",
      day: "2-digit",
    }).format(new Date(date));
  };

  useEffect(() => {
    const printStyles = `
      @media print {
        @page { size: A4; margin: 8mm; }
        body { margin: 0; }
        table { page-break-inside: auto; }
        tr { page-break-inside: avoid; page-break-after: auto; }
      }
    `;

    const styleSheet = document.createElement("style");
    styleSheet.type = "text/css";
    styleSheet.innerText = printStyles;
    document.head.appendChild(styleSheet);

    return () => {
      document.head.removeChild(styleSheet);
    };
  }, []);

  if (!labTest || !tests || tests.length === 0) {
    return null;
  }

  const groupedByCategory = tests.reduce((acc, test) => {
    const category = test?.test_type_display?.category?.name || "General";
    if (!acc[category]) acc[category] = [];
    acc[category].push(test);
    return acc;
  }, {});

  return (
    <ClinicPrintFrame
      doctorName={labTest?.doctor_display?.username || "Laboratory"}
      doctorTitle="Laboratory Test Result"
      date={formatDate(labTest?.order_date)}
      patientName={labTest?.patient_display?.username}
      patientAge={labTest?.patient_display?.age}
      patientGender={labTest?.patient_display?.gender}
      leftNotes={["LAB", "CBC", "BIO", "SER"]}
      rxTitle="Lab"
      compact
    >
      {Object.entries(groupedByCategory).map(([category, categoryTests]) => (
        <div key={category} style={{ marginBottom: "14px" }}>
          <div
            style={{
              fontWeight: "bold",
              fontSize: "3.4mm",
              marginBottom: "6px",
              color: "#0b8eb0",
            }}
          >
            {category}
          </div>

          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th style={headerCell}>Test Name</th>
                <th style={headerCell}>Result</th>
                <th style={headerCell}>Unit</th>
                <th style={headerCell}>Normal Range</th>
                <th style={headerCell}>Status</th>
              </tr>
            </thead>
            <tbody>
              {categoryTests.map((test, idx) => {
                const display = test.test_type_display || {};
                const normalRange = display.reference_range
                  ? `${display.reference_range}${display.units ? ` ${display.units}` : ""}`
                  : display.min_value !== null && display.max_value !== null
                  ? `${display.min_value} - ${display.max_value}${display.units ? ` ${display.units}` : ""}`
                  : "";

                const status = display.is_within_normal_range_display || "";
                const normal = status === "Normal";

                return (
                  <tr key={idx}>
                    <td style={bodyCell}>{display.name}</td>
                    <td style={{ ...bodyCell, fontWeight: 700 }}>{display.result_value}</td>
                    <td style={bodyCell}>{display.units}</td>
                    <td style={bodyCell}>{normalRange}</td>
                    <td style={{ ...bodyCell, color: normal ? "#198754" : "#d63384", fontWeight: 700 }}>
                      {status}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ))}
    </ClinicPrintFrame>
  );
};

export default LaboratoryResultPaper;
